import util from '@bmp-vue/core/api/util'
const controller = 'Usuario'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetEmailGerentes: function () {
    return util.Axios.GetAll(controller + '/GetEmailGerentes')
  },
  GetEmailMasters: function () {
    return util.Axios.GetAll(controller + '/GetEmailMasters')
  }
})
